export default __webpack_public_path__ + "static/thumb-dda6429075e4db7c7eccee49cb8eeb8e.png";